import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-lesson-video.tsx
var LazyCourseLessonVideo = lazy(() => import("./course-lesson-video-BhPchzri.js").then((n) => n.n).then((module) => ({ default: module.CourseLessonVideo })));
function CourseLessonVideo(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-video" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonVideo, { ...props })
	});
}
function CourseLessonVideoContent(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-video" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonVideo, { ...props })
	});
}
var useCourseLessonVideoContent = () => {
	return useMemo(() => ({ courseLessonVideo: { component: CourseLessonVideoContent } }), []);
};
//#endregion
export { CourseLessonVideo, useCourseLessonVideoContent };
